var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsEnum, IsNumber, IsObject, IsOptional, IsString, IsUUID, MaxLength, } from 'class-validator';
import { ExerciseFullSizeDto } from '../../exercise/dtos/exercise.full-size.dto.js';
import { TrainingSessionItemFullSizeDto } from '../../training-sessions/index.js';
import { ExercisePerformanceType } from '../enums/exercise-performance-type.enum.js';
import { ExerciseProgramLiteDto } from './exercise-program.lite.dto.js';
export class ExerciseProgramItemFullSizeDto {
    id;
    createdAt;
    updatedAt;
    deletedFromProgram;
    exerciseId;
    exerciseProgramId;
    customIndication;
    performanceType = ExercisePerformanceType.REPITITION;
    performanceContent;
    setCount;
    pauseDuration;
    weight;
    exercise;
    trainingSessionItems;
    exerciseProgram;
    sortId;
    sortIndex;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ExerciseProgramItemFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ExerciseProgramItemFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ExerciseProgramItemFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ExerciseProgramItemFullSizeDto.prototype, "deletedFromProgram", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ExerciseProgramItemFullSizeDto.prototype, "exerciseId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseProgramItemFullSizeDto.prototype, "exerciseProgramId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    MaxLength(255),
    __metadata("design:type", Object)
], ExerciseProgramItemFullSizeDto.prototype, "customIndication", void 0);
__decorate([
    IsEnum(ExercisePerformanceType),
    Expose(),
    __metadata("design:type", String)
], ExerciseProgramItemFullSizeDto.prototype, "performanceType", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseProgramItemFullSizeDto.prototype, "performanceContent", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseProgramItemFullSizeDto.prototype, "setCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseProgramItemFullSizeDto.prototype, "pauseDuration", void 0);
__decorate([
    IsNumber(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], ExerciseProgramItemFullSizeDto.prototype, "weight", void 0);
__decorate([
    Expose(),
    Type(() => ExerciseFullSizeDto),
    IsObject(),
    __metadata("design:type", ExerciseFullSizeDto)
], ExerciseProgramItemFullSizeDto.prototype, "exercise", void 0);
__decorate([
    IsArray(),
    Type(() => TrainingSessionItemFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], ExerciseProgramItemFullSizeDto.prototype, "trainingSessionItems", void 0);
__decorate([
    IsArray(),
    Type(() => ExerciseProgramLiteDto),
    Exclude(),
    __metadata("design:type", Function)
], ExerciseProgramItemFullSizeDto.prototype, "exerciseProgram", void 0);
__decorate([
    Exclude(),
    __metadata("design:type", String)
], ExerciseProgramItemFullSizeDto.prototype, "sortId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ExerciseProgramItemFullSizeDto.prototype, "sortIndex", void 0);
//# sourceMappingURL=exercise-program-item.full-size.dto.js.map